import React from 'react';
import Icon from '../../../components/AppIcon';

const PrivacyToggle = ({ isPublic, onToggle }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-sm">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10">
            <Icon 
              name={isPublic ? 'Eye' : 'EyeOff'} 
              size={20} 
              color="var(--color-primary)" 
            />
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground">
              {isPublic ? 'Public Profile' : 'Private Profile'}
            </p>
            <p className="text-xs text-muted-foreground">
              {isPublic ? 'Visible on leaderboards' : 'Hidden from rankings'}
            </p>
          </div>
        </div>
        <button
          onClick={() => onToggle(!isPublic)}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-smooth
            ${isPublic ? 'bg-primary' : 'bg-muted'}
          `}
          role="switch"
          aria-checked={isPublic}
        >
          <span
            className={`
              inline-block h-4 w-4 transform rounded-full bg-white shadow-md transition-smooth
              ${isPublic ? 'translate-x-6' : 'translate-x-1'}
            `}
          />
        </button>
      </div>
      {!isPublic && (
        <div className="mt-3 pt-3 border-t border-border">
          <p className="text-xs text-muted-foreground flex items-center gap-2">
            <Icon name="Info" size={14} color="var(--color-muted-foreground)" />
            You can still view leaderboards, but your name won't appear in rankings
          </p>
        </div>
      )}
    </div>
  );
};

export default PrivacyToggle;